export default {
  skin: {
    pageClass: 'project1',
    pageTitle: '凝聚FK的智慧和优雅',
    data: [
      {
        id: '115',
        name: '日式脱毛净肌',
        title: '温和高效的脱毛、脱毛和嫩肤功效兼具',
        thumb: 'pro-photo16.jpg',
        intro:
          'FK引入日本先进的智能综合脱毛仪，以备受日本女性欢迎的IPL+SHR科技，带来兼具效用与柔和感的愉悦日式净肌体验。它无痛、脱毛效率又极高。利用光学技术光与黑色素发生反应并产生热量，热量通过毛发传递到达毛囊，使毛发组织无法接收营养，从而达到毛发无法生长的效果。日本沙龙脱毛仪能量阈值远大于家用仪器，周期操作效用卓著，但也并非一次绝毛。光学照射脱毛的目标是处于生长期的毛发（大约5%-15%的毛处于生长期），这便是一次可以达到有效脱毛的百分比，也是为什么“脱毛不能一次完成”的原因。一般需要规律的7次以上的施术达到理想的效果。',
        time: '15分（不等）',
        price: '见价目表',
        priceBtn: true,
        // priceList: [
        //   { type: 'level1', value: 610 },
        //   { type: 'level2', value: 567 },
        //   { type: 'level3', value: 539 },
        // ],
        priceInfo: {
          p: require('@/assets/m115.jpg'),
          m: require('@/assets/m115.jpg'),
        },
        position: '腋下/唇周/手指/脚趾/下巴/手背/脚背/额头/鬓角/手肘/乳沟/乳晕/腹部/膝盖/发际线/前胸上/前胸下/后背上/后背/全脸/大腿/小腿/颈后/小臂/大臂/比基尼私处(V+I+O)',
        points: [
          {
            name: 'POINT 1',
            text: '除毛，并遮盖纹身、痣等黑色区域。',
            thumb: 'pd-img51.jpg',
          },
          {
            name: 'POINT 2',
            text: '涂抹嫩肤凝胶，开始照射。根据区域大小和毛发量，照射时间不同。',
            thumb: 'pd-img52.jpg',
          },
          {
            name: 'POINT 3',
            text: '照射结束。求美者需间隔30天，规律进行照射。',
            thumb: 'pd-img53.jpg',
          },
        ],
      },
      {
        id: '114',
        name: 'DEP婴儿胶原超导 <i class="mBlock"></i>Baby Collagen Infusion',
        title: '婴儿胶原直补 嫩肤亮白',
        thumb: 'pro-photo15.jpg',
        intro:
          '胶原蛋白损伤是面部衰老的根源。Ⅲ型胶原又被称为婴儿胶原，决定皮肤细腻度和弹性，因此面部Ⅲ型胶原损伤或流失，面部将出现：缺水/干燥/毛孔粗大/敏感/皱 纹/色斑/组织塌陷/松弛/下垂等问题，成年人需要外源补充Ⅲ型胶原来对抗衰老。‘DEP婴儿胶原超导’利用意大利DEP无创透皮给药系统，将Jinbo锦波生物|重源生美专业线的2款产品：‘Ⅲ型胶原超级肽’及‘Ⅲ型胶原亮白肽’导入至肌肤真皮层及肌膜，比传统的离子导入疗法更快、层次更深，效果卓越。是FK倾力打造的胶原直补品相。',
        time: '45分',
        price: '¥718（新人价 ¥410）',
        priceInfo: {
          p: require('@/assets/p114.jpg'),
          m: require('@/assets/p114.jpg'),
        },
        priceList: [
          { type: 'level1', value: 610 },
          { type: 'level2', value: 567 },
          { type: 'level3', value: 539 },
        ],
        position: '面部',
        points: [
          {
            name: 'POINT 1',
            text: '进行温和的卸妆/洁面工作，使肌肤通透无负担。',
            thumb: 'pd-img1.png',
          },
          {
            name: 'POINT 2',
            text: '使用DEP透皮给药系统进行锦波生物Ⅲ型胶原导入，‘胶原超级肽’或‘胶原亮白肽’二选一。',
            thumb: 'pd-img50.jpg',
          },
          {
            name: 'POINT 3',
            text: '使用pdp玻尿酸保湿面膜，镇静肌肤。同时进行肩颈放松按摩，倍感轻松的护理体验。',
            thumb: 'pd-img15.png',
          },
          {
            name: 'POINT 4',
            text: '使用pdp细胞赋颜弹力系列保养品，还原婴儿般胶原满满的Q滑状态。',
            thumb: 'pd-img4.png',
          },
        ],
      },
      {
        id: '113',
        name: '科医人Geneo X氧气嫩肤',
        title: '内增氧外滋养，对抗肤质老化',
        thumb: 'pro-photo13.jpg',
        // thumbHover: "pro-photo9-1.png",
        intro: '源自以色列科医人院线品牌GeneoX多功效护理项目，通过专利黑科技技术：内增氧，外滋养，对抗肤质老化，解决各类肌肤问题。通过沉浸式“焕氧-滋养-紧致”三步，配合灌注天然成分功效型氧肤活力弹，提升肌肤内源氧含量，解决各类肌肤问题，实现氧气嫩肤，素颜自由。',
        time: '60分',
        price: '¥1750/部位（新人价 ¥980）',
        priceInfo: {
          p: require('@/assets/p113.jpg'),
          m: require('@/assets/p113.jpg'),
        },
        priceList: [
          { type: 'level1', value: 1488 },
          { type: 'level2', value: 1383 },
          { type: 'level3', value: 1313 },
        ],
        position: '面部或颈部',
        sliderM: ['pro-m-slider21.jpg', 'pro-m-slider22.jpg', 'pro-m-slider23.jpg', 'pro-m-slider24.jpg', 'pro-m-slider25.jpg'],
        // sliderInnerTextP: [
        //   '<p class="st2" style="margin-bottom: 8px;">水光弹</p><p class="st3" style="margin-bottom: 16px;">深层保湿、水润紧致、锁水屏障</p><p class="st3"><span>·</span><span>积雪草苷：修复屏障、稳肤强韧</span></p><p class="st3"><span>·</span><span>烟酰胺：水溶性成分，促进表皮层蛋白质的合成，改善肌肤质地，使肌肤更加柔嫩</span></p><p class="st3"><span>·</span><span>透明质酸：稳定锁水屏障、锁住肌肤水分</span></p><p class="st3"><span>·</span><span>三重修复天然油脂：天然皮肤保湿剂、滋养修护肌肤，超强缩水力</span></p>',

        //   '<p class="st2" style="margin-bottom: 8px;">Calming Milk 镇静、修复敏感脆弱肌肤</p><p class="st3" style="margin-bottom: 16px;">主要成分：99.9%金盏菊花萃取物与向日葵籽油</p><p class="st3"><span>·</span><span>抗炎，抗菌，治疗皮肤炎症和敏感、感染</span></p><p class="st3"><span>·</span><span>非常适合皮肤干燥或破裂人群</span></p><p class="st3"><span>·</span><span>改善肌肤紧致和水润</span></p>',

        //   '<p class="st2" style="margin-bottom: 8px;">Anti Aging 天然保湿剂、重塑皮脂腺</p><p class="st3" style="margin-bottom: 16px;">主要成分: 100%荷荷巴油</p><p class="st3"><span>·</span><span>100%顶级有机荷荷巴油(荷荷巴油类似于皮肤的天然皮脂，可作为天然保湿剂和保护皮肤)</span></p><p class="st3"><span>·</span><span>通过锁住水分来形成保护层，重塑皮脂腺</span></p><p class="st3"><span>·</span><span>天然的润肤霜，防止肌肤脱水</span></p><p class="st3"><span>·</span><span>修复干燥与受损皮肤</span></p>',

        //   '<p class="st2" style="margin-bottom: 8px;">BTX 无需注射抑制皱纹</p><p class="st3" style="margin-bottom: 16px;">主要成分: 六胜肽-8(类肉毒杆菌)</p><p class="st3"><span>·</span><span>Hexapeptide-8（六胜肽-8一种模拟BOTOX在皮肤中的作用而没有任何副作用的胜肽）</span></p><p class="st3"><span>·</span><span>无需注射但拥有肉毒素的祛纹效果，可以放松浅表肌肉，滑润和舒缓纹理和皱纹</span></p><p class="st3"><span>·</span><span>调节肌肉收缩以抑制皱纹的产生</span></p><p class="st3"><span>·</span><span>收紧松弛下垂的皮肤</span></p>',
        // ],
        // sliderInnerTextM: [
        //   '<p class="st1">Wish Care<br>深海海藻修复精粹</p><p class="st3" style="margin-top: 24px;">主要成分: 深海3000米的极端微生物的海藻类与金盏花提取物</p>',
        //   '<p class="st1">Calming Milk<br>镇静、修复敏感脆弱肌肤</p><p class="st3" style="margin-top: 24px;">主要成分: 99.9%金盏菊花萃取物与向日葵籽油</p>',
        //   '<p class="st1">Anti Aging<br>以油治干、重塑屏障</p><p class="st3" style="margin-top: 24px;">主要成分: 100%荷荷巴油</p>',
        //   '<p class="st1">BTX<br>无需注射抑制皱纹</p><p class="st3" style="margin-top: 24px;">主要成分: 六胜肽-8(类肉毒杆菌)</p>',
        // ],
        sliderText: [
          '<p><span>·</span><span>积雪草苷：修复屏障、稳肤强韧</span></p><p><span>·</span><span>烟酰胺：水溶性成分，促进表皮层蛋白质的合成，改善肌肤质地，使肌肤更加柔嫩</span></p><p><span>·</span><span>透明质酸：稳定锁水屏障、锁住肌肤水分</span></p><p><span>·</span><span>三重修复天然油脂：天然皮肤保湿剂、滋养修护肌肤，超强缩水力</span></p>',

          '<p><span>·</span><span>藻类提取物：从肌底根源修护改善皮肤，自愈新生</span></p><p><span>·</span><span>胜肽：促进胶原蛋白、弹力纤维、透明质酸增生</span></p><p><span>·</span><span>雪绒花精粹：强抗氧化、促进胶原蛋白合成</span></p><p><span>·</span><span>视黄醇：改善皮肤光老化，减少脸部细纹和皱纹抚平肌肤，促进胶原新生</span></p>',

          '<p><span>·</span><span>竹炭：多孔结构、祛除污垢</span></p><p><span>·</span><span>杏仁酸 2%：疏通毛孔中的油脂、对抗痤疮、改善肌肤纹理</span></p><p><span>·</span><span>水杨酸 0.5%：清理毛孔、去角质、促进新陈代谢</span></p><p><span>·</span><span>苦橙果提取物：安定舒缓、皮肤修红</span></p>',

          '<p><span>·</span><span>曲酸 2% ：抑制络氨酸酶、均匀肤色、淡化斑点、抗氧化</span></p><p><span>·</span><span>维C衍生物：抑制络氨酸酶的生成、抑制黑色素</span></p><p><span>·</span><span>二乙酰基波尔定碱：抑制黑色素生成</span></p><p><span>·</span><span>α-熊果苷：淡褪黑色素、层层润透、加快肌肤新陈代谢</span></p>',

          '<p><span>·</span><span>绿茶提取物：收缩毛孔、抵抗自由基</span></p><p><span>·</span><span>欧洲白睡莲：调理肌肤、滋养肌肤</span></p><p><span>·</span><span>舒缓复合物：抑制炎症因子</span></p><p><span>·</span><span>棕榈酰脯氨酸钠：抵御外界环境刺激、降低表皮温度</span></p>',
        ],
        sliderP: ['pro-p-slider21.jpg', 'pro-p-slider22.jpg', 'pro-p-slider23.jpg', 'pro-p-slider24.jpg', 'pro-p-slider25.jpg'],
        points: [
          {
            name: 'POINT 1',
            text: '进行温和的卸妆、洁面工作，使肌肤通透无负担。',
            thumb: 'pd-img42.jpg',
          },
          {
            name: 'POINT 2',
            text: 'OxyGeneo®技术，配合活力弹，提升肌肤内源氧含量。',
            thumb: 'pd-img43.jpg',
          },
          {
            name: 'POINT 3',
            text: 'Sonic技术，打开肌肤吸收通道。',
            thumb: 'pd-img44.jpg',
          },
          {
            name: 'POINT 4',
            text: '舒缓式淋巴引流按摩，收紧肌肤、轮廓立显。',
            thumb: 'pd-img45.jpg',
          },
          {
            name: 'POINT 5',
            text: '使用pdp玻尿酸保湿面膜，镇静肌肤。',
            thumb: 'pd-img15.png',
          },
          {
            name: 'POINT 6',
            text: '涂抹后续保养品，再生及保护肌肤。',
            thumb: 'pd-img47.jpg',
          },
        ],
      },
      {
        id: '112',
        name: 'Timeless蓄热超声分层抗衰',
        title: '温和版聚焦超声波',
        thumb: 'pro-photo12.jpg',
        // thumbHover: "pro-photo9-1.png",
        intro:
          'Timeless是一种先进的集合半导体制冷+高强度聚焦超声波(HIFU)技术于一体的高科技抗衰设备，技术源自意大利。凭借冰点创新引入，可有效降低组织或表皮容易“被灼伤”风险，使疗效更安全，舒适度更高。蓄热超声专注提升面部，修饰轮廓线，塑造丰满苹果肌，促进胶原蛋白新生，淡化去除皱纹细纹，提亮肤色，改善眼周细纹松弛，紧致肌肤恢复弹性，收紧双下巴，减淡颈纹。',
        time: '60分',
        price: '¥6800（新人价 ¥1780）',
        priceInfo: {
          p: require('@/assets/p112.jpg'),
          m: require('@/assets/p112.jpg'),
        },
        priceList: [
          { type: 'level1', value: 5780 },
          { type: 'level2', value: 5372 },
          { type: 'level3', value: 5100 },
        ],
        position: '面部或颈部',
        points: [
          {
            name: 'POINT 1',
            text: '进行温和的卸妆、洁面工作，使肌肤通透无负担。',
            thumb: 'pd-img39.jpg',
          },
          {
            name: 'POINT 2',
            text: '以4.5mm 探头、3.0mm 探头、2.0mm 顺序次第操作于护理部位。',
            thumb: 'pd-img40.jpg',
          },
          {
            name: 'POINT 3',
            text: '贴片冰玲韵医用冷敷膜。',
            thumb: 'pd-img32.png',
          },
          {
            name: 'POINT 4',
            text: '涂抹后续保养品，再生及保护肌肤。',
            thumb: 'pd-img41.jpg',
          },
        ],
      },
      {
        id: '111',
        name: 'P.02油养肤温感石膏护理',
        title: '保湿抗衰，亮泽肌肤',
        thumb: 'pro-photo11.png',
        // thumbHover: "pro-photo9-1.png",
        intro: 'pdp品牌旗下全新上市的石膏新系列——‘油养肤’，特别针对干燥肌肤，补充多重油脂及抗衰成分，达到水油平衡、光泽透亮的肌肤状态。',
        time: '50分',
        price: '¥650（新人价 ¥390）',
        priceList: [
          { type: 'level1', value: 553 },
          { type: 'level2', value: 514 },
          { type: 'level3', value: 488 },
        ],
        priceInfo: {
          p: require('@/assets/p109.jpg'),
          m: require('@/assets/p109.jpg'),
        },
        position: '面部',
        points: [
          {
            name: 'POINT 1',
            text: '进行温和的卸妆/洁面工作，使肌肤通透无负担。',
            thumb: 'pd-img33.jpg',
          },
          {
            name: 'POINT 2',
            text: '使用乳糖酸柔肤凝胶，涂于面部静置2分钟，后涂抹精致水。',
            thumb: 'pd-img34.jpg',
          },
          {
            name: 'POINT 3',
            text: '使用蛋黄油凝脂，配合日本小颜紧致手法进行面颈部提升按摩10分钟。',
            thumb: 'pd-img35.jpg',
          },
          {
            name: 'POINT 4',
            text: '使用凝时精华油涂于面部。后取出菁颜双膜，分别贴于眼下及法令纹处。',
            thumb: 'pd-img36.jpg',
          },
          {
            name: 'POINT 5',
            text: '将用纯净水浸湿的面膜纸，拧干多余水分贴在脸上，并将搅拌后的石膏覆盖其上。',
            thumb: 'pd-img37.jpg',
          },
          {
            name: 'POINT 6',
            text: '15分钟后先确认面膜温度是否开始下降，然后将面膜从两侧抬起，涂抹水乳等后续保养品即可。',
            thumb: 'pd-img38.jpg',
          },
        ],
      },
      {
        id: '109',
        name: 'P.01抗糖化温感石膏护理',
        title: '高效快捷嫩白肌肤，抗衰抗糖',
        thumb: 'pro-photo9.png',
        // thumbHover: "pro-photo9-1.png",
        intro:
          '石膏护理起源于“美容之乡”法国，距今已有50年的历史。石膏面膜是一种将美容液或乳霜涂抹在肌肤表层，然后在其上用石膏涂抹并包裹住的施术方法。通过用石膏覆盖面部，使美容液的成分渗入皮肤，并且使皮肤发热加快新陈代谢，排出多余的废物。同时排出的废物被石膏吸收，矿物质从石膏中释放出来，渗入肌肤底层。',
        time: '45分',
        price: '¥650（新人价 ¥390）',
        priceList: [
          { type: 'level1', value: 553 },
          { type: 'level2', value: 514 },
          { type: 'level3', value: 488 },
        ],
        priceInfo: {
          p: require('@/assets/p109.jpg'),
          m: require('@/assets/p109.jpg'),
        },
        position: '面部',
        points: [
          {
            name: 'POINT 1',
            text: '进行温和的卸妆/洁面工作，使肌肤通透无负担。',
            thumb: 'pd-img21.png',
          },
          {
            name: 'POINT 2',
            text: '配合日本小颜紧致手法进行面部提升按摩10分钟。',
            thumb: 'pd-img22.png',
          },
          {
            name: 'POINT 3',
            text: '将酵母精华、3D玻尿酸保湿原液均匀涂抹于全脸和脖子。并将保湿精华纸贴分别贴于眼下及法令纹处，并铺展平整。',
            thumb: 'pd-img23.png',
          },
          {
            name: 'POINT 4',
            text: '将用纯净水浸湿的面膜纸，拧干多余水分，贴在脸上，并将搅拌后的石膏面膜敷于面部静置。',
            thumb: 'pd-img24.png',
          },
          {
            name: 'POINT 5',
            text: '15分钟后先确认面膜温度是否开始下降，然后将面膜从两侧抬起，涂抹水乳等后续保养品即可。',
            thumb: 'pd-img25.png',
          },
        ],
      },
      {
        id: '110',
        name: 'P.e1美目温感石膏眼部护理',
        title: '眼周弹力紧致，保湿亮肤，缓解眼疲劳',
        thumb: 'pro-photo10.png',
        // thumbHover: "pro-photo10-1.png",
        intro:
          '这是石膏应用于美容护肤领域，一次极具创新的尝试。美目温感石膏系列，将“鲨鱼三肽”、蛋黄油、依克多因、视黄醇棕榈酸酯、凝血酸等针对性成分应用在产品中，透过石膏天然的重力、热能，和极强的封闭性，使珍贵营养渗透至肌肤深层，来满足眼周弹性、保湿、抗皱、亮肤等多重特定需求，同时加速眼周微循环，缓解眼疲劳，缓解青眼圈。',
        time: '45分',
        price: '¥580（新人价 ¥350）',
        priceList: [
          { type: 'level1', value: 493 },
          { type: 'level2', value: 458 },
          { type: 'level3', value: 435 },
        ],
        priceInfo: {
          p: require('@/assets/p109.jpg'),
          m: require('@/assets/p109.jpg'),
        },
        position: '眼周',
        points: [
          {
            name: 'POINT 1',
            text: '进行温和的卸妆/洁面工作，使肌肤通透无负担。',
            thumb: 'pd-img26.png',
          },
          {
            name: 'POINT 2',
            text: '配合日式眼周拨筋按摩手法，进行眼周舒缓按摩10分钟。',
            thumb: 'pd-img27.png',
          },
          {
            name: 'POINT 3',
            text: '取出一半用量的眼霜涂抹于眼周，后取出蝴蝶眼贴覆盖其上。',
            thumb: 'pd-img28.png',
          },
          {
            name: 'POINT 4',
            text: '将用纯净水浸湿的眼膜纸平整贴在眼部，并将搅拌后的石膏眼膜敷于眼部静置。',
            thumb: 'pd-img29.png',
          },
          {
            name: 'POINT 5',
            text: '15分钟后先确认眼膜温度是否开始下降，然后将面膜从两侧抬起，涂抹眼霜、水乳等后续保养品即可。',
            thumb: 'pd-img30.png',
          },
        ],
      },
      {
        id: '101',
        name: 'Whisper量肤定制智能胶囊护理',
        title: '以活性成分灌注实现肌肤年轻态',
        thumb: 'pro-photo8.png',
        intro: 'Whisper是一款引进自以色列的，量肤定制的非入侵治疗设备，通过特有的MIT技术（磁性输液技术），提高真皮层的微循环，提高淋巴的代谢率，配合智能活性成分海绵胶囊，能在无针无创、100%安全和舒适的情况下，15分钟将胶囊内的活性成分注入皮肤深处，并导入细胞内，让细胞充盈，皮肤饱满有光泽。',
        time: '40分',
        price: '¥1600（新人价 ¥580）',
        priceList: [
          { type: 'level1', value: 1360 },
          { type: 'level2', value: 1264 },
          { type: 'level3', value: 1200 },
        ],
        priceInfo: {
          p: require('@/assets/p101.jpg'),
          m: require('@/assets/p101.jpg'),
        },
        position: '面部或颈部',
        sliderM: ['pro-m-slider7.png', 'pro-m-slider6.png', 'pro-m-slider1.png', 'pro-m-slider2.png', 'pro-m-slider3.png', 'pro-m-slider4.png', 'pro-m-slider5.png', 'pro-m-slider8.png', 'pro-m-slider9.png', 'pro-m-slider10.png'],
        sliderInnerTextP: [
          '<p class="st2" style="margin-bottom: 8px;">Wish Care深海海藻修复精粹</p><p class="st3" style="margin-bottom: 16px;">主要成分：深海3000米的极端微生物的海藻类与金盏花提取物</p><p class="st3"><span>·</span><span>广泛应用于受损肌肤，15分钟的快速褪红</span></p><p class="st3"><span>·</span><span>增强肌肤免疫力</span></p><p class="st3"><span>·</span><span>抗炎，抗菌，暗疮护理</span></p><p class="st3"><span>·</span><span>肌肤伤口愈合</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">Calming Milk 镇静、修复敏感脆弱肌肤</p><p class="st3" style="margin-bottom: 16px;">主要成分：99.9%金盏菊花萃取物与向日葵籽油</p><p class="st3"><span>·</span><span>抗炎，抗菌，治疗皮肤炎症和敏感、感染</span></p><p class="st3"><span>·</span><span>非常适合皮肤干燥或破裂人群</span></p><p class="st3"><span>·</span><span>改善肌肤紧致和水润</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">Anti Aging 天然保湿剂、重塑皮脂腺</p><p class="st3" style="margin-bottom: 16px;">主要成分: 100%荷荷巴油</p><p class="st3"><span>·</span><span>100%顶级有机荷荷巴油(荷荷巴油类似于皮肤的天然皮脂，可作为天然保湿剂和保护皮肤)</span></p><p class="st3"><span>·</span><span>通过锁住水分来形成保护层，重塑皮脂腺</span></p><p class="st3"><span>·</span><span>天然的润肤霜，防止肌肤脱水</span></p><p class="st3"><span>·</span><span>修复干燥与受损皮肤</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">BTX 无需注射抑制皱纹</p><p class="st3" style="margin-bottom: 16px;">主要成分: 六胜肽-8(类肉毒杆菌)</p><p class="st3"><span>·</span><span>Hexapeptide-8（六胜肽-8一种模拟BOTOX在皮肤中的作用而没有任何副作用的胜肽）</span></p><p class="st3"><span>·</span><span>无需注射但拥有肉毒素的祛纹效果，可以放松浅表肌肉，滑润和舒缓纹理和皱纹</span></p><p class="st3"><span>·</span><span>调节肌肉收缩以抑制皱纹的产生</span></p><p class="st3"><span>·</span><span>收紧松弛下垂的皮肤</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">Neo Energy 强化胶原蛋白</p><p class="st3" style="margin-bottom: 16px;">主要成分: 胶原和弹力蛋白填充物</p><p class="st3"><span>·</span><span>改善皮肤密度和饱满度，针对干瘪无胶原的高龄肌肤，增加皮肤弹力</span></p><p class="st3"><span>·</span><span>在15天内，预计可减少皱纹深度15%左右，减少皱纹体积13%</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">Repairing 强化补水、提高锁水力</p><p class="st3" style="margin-bottom: 16px;">主要成分: 大、小分子玻尿酸</p><p class="st3"><span>·</span><span>双重玻尿酸，强化补水及提高表皮、真皮层锁水力</span></p><p class="st3"><span>·</span><span>防止水分流失，减缓脱水，内外补水</span></p><p class="st3"><span>·</span><span>促进细胞修复，加速肌肤更新</span></p><p class="st3"><span>·</span><span>刺激胶原蛋白形成</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">Whitening 淡斑美白提亮肤色</p><p class="st3" style="margin-bottom: 16px;">主要成分: 褐色海藻提取物</p><p class="st3"><span>·</span><span>海藻精华和B -White活性成分抑制黑色素机制</span></p><p class="st3"><span>·</span><span>改善肤色，提亮肤色，抑制黑色素产生</span></p><p class="st3"><span>·</span><span>针对深、浅层斑，有很好的淡化效果</span></p><p class="st3"><span>·</span><span>皮肤亮白度显著增加</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">Hyaluronic 水盈抗氧水油同补</p><p class="st3" style="margin-bottom: 16px;">主要成分: 大分子透明质酸、杜氏海藻提取物、5%葡萄籽油</p><p class="st3"><span>·</span><span>复合型配方结构</span></p><p class="st3"><span>·</span><span>为熟龄肌肤补水抗氧</span></p><p class="st3"><span>·</span><span>提供更多可能性</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">Peel 净面光环胶囊</p><p class="st3" style="margin-bottom: 16px;">主要成分: 95%甜杏仁油、奇华顿蓝白色颗粒(VE、B5)</p><p class="st3"><span>·</span><span>可增加细胞带氧能力，加快肌肤代谢</span></p><p class="st3"><span>·</span><span>含有的蓝白色奇华顿颗粒</span></p><p class="st3"><span>·</span><span>利用专利的生物溶解技术</span></p><p class="st3"><span>·</span><span>皮肤呈现透、亮、白、嫩、滑</span></p>',

          '<p class="st2" style="margin-bottom: 8px;">Rejuvenation 乳木果面部护理液</p><p class="st3" style="margin-bottom: 16px;">主要成分: 99%非洲乳木果优质油</p><p class="st3"><span>·</span><span>乳木果带来独特的‘膜’感护肤</span></p><p class="st3"><span>·</span><span>具有优越的肌肤再生修复和保湿功能</span></p><p class="st3"><span>·</span><span>可保护皮脂膜，深入滋养肌肤</span></p><p class="st3"><span>·</span><span>保持肌肤弹力，抗氧化</span></p>',
        ],
        sliderInnerTextM: [
          '<p class="st1">Wish Care<br>深海海藻修复精粹</p><p class="st3" style="margin-top: 24px;">主要成分: 深海3000米的极端微生物的海藻类与金盏花提取物</p>',
          '<p class="st1">Calming Milk<br>镇静、修复敏感脆弱肌肤</p><p class="st3" style="margin-top: 24px;">主要成分: 99.9%金盏菊花萃取物与向日葵籽油</p>',
          '<p class="st1">Anti Aging<br>以油治干、重塑屏障</p><p class="st3" style="margin-top: 24px;">主要成分: 100%荷荷巴油</p>',
          '<p class="st1">BTX<br>无需注射抑制皱纹</p><p class="st3" style="margin-top: 24px;">主要成分: 六胜肽-8(类肉毒杆菌)</p>',
          '<p class="st1">Neo Energy<br>强化胶原蛋白</p><p class="st3" style="margin-top: 24px;">主要成分: 胶原和弹力蛋白填充物</p>',
          '<p class="st1">Repairing<br>强化补水、提高锁水力</p><p class="st3" style="margin-top: 24px;">主要成分: 大、小分子玻尿酸</p>',
          '<p class="st1">Whitening<br>淡斑美白提亮肤色</p><p class="st3" style="margin-top: 24px;">主要成分: 褐色海藻提取物</p>',
          '<p class="st1">Hyaluronic<br>水盈抗氧水油同补</p><p class="st3" style="margin-top: 24px;">主要成分: 大分子透明质酸、杜氏海藻提取物、5%葡萄籽油</p>',
          '<p class="st1">Peel<br>净面光环胶囊</p><p class="st3" style="margin-top: 24px;">主要成分: 95%甜杏仁油、奇华顿蓝白色颗粒(VE、B5)</p>',
          '<p class="st1">Rejuvenation<br>乳木果面部护理液</p><p class="st3" style="margin-top: 24px;">主要成分: 99%非洲乳木果优质油</p>',
        ],
        sliderText: [
          '<p><span>·</span><span>广泛应用于受损肌肤，15分钟的快速褪红</span></p><p><span>·</span><span>增强肌肤免疫力</span></p><p><span>·</span><span>抗炎，抗菌，暗疮护理</span></p><p><span>·</span><span>肌肤伤口愈合</span></p>',
          '<p><span>·</span><span>抗炎，抗菌，治疗皮肤炎症和敏感、感染</span></p><p><span>·</span><span>非常适合皮肤干燥或破裂人群</span></p><p><span>·</span><span>改善肌肤紧致和水润</span></p>',
          '<p><span>·</span><span>100%顶级有机荷荷巴油(荷荷巴油类似于皮肤的天然皮脂，可作为天然保湿剂和保护皮肤)</span></p><p><span>·</span><span>通过锁住水分来形成保护层，重塑皮脂腺</span></p><p><span>·</span><span>天然的润肤霜，防止肌肤脱水</span></p><p><span>·</span><span>修复干燥与受损皮肤</span></p>',
          '<p><span>·</span><span>Hexapeptide-8（六胜肽-8一种模拟BOTOX在皮肤中的作用而没有任何副作用的胜肽）</span></p><p><span>·</span><span>无需注射但拥有肉毒素的祛纹效果，可以放松浅表肌肉，滑润和舒缓纹理和皱纹</span></p><p><span>·</span><span>调节肌肉收缩以抑制皱纹的产生</span></p><p><span>·</span><span>收紧松弛下垂的皮肤</span></p>',
          '<p><span>·</span><span>改善皮肤密度和饱满度，针对干瘪无胶原的高龄肌肤，增加皮肤弹力</span></p><p><span>·</span><span>在15天内，预计可减少皱纹深度15%左右，减少皱纹体积13%</span></p>',
          '<p><span>·</span><span>双重玻尿酸，强化补水及提高表皮、真皮层锁水力</span></p><p><span>·</span><span>防止水分流失，减缓脱水，内外补水</span></p><p><span>·</span><span>促进细胞修复，加速肌肤更新</span></p><p><span>·</span><span>刺激胶原蛋白形成</span></p>',
          '<p><span>·</span><span>海藻精华和B -White活性成分抑制黑色素机制</span></p><p><span>·</span><span>改善肤色，提亮肤色，抑制黑色素产生</span></p><p><span>·</span><span>针对深、浅层斑，有很好的淡化效果</span></p><p><span>·</span><span>皮肤亮白度显著增加</span></p>',
          '<p><span>·</span><span>复合型配方结构</span></p><p><span>·</span><span>为熟龄肌肤补水抗氧</span></p><p><span>·</span><span>提供更多可能性</span></p>',
          '<p><span>·</span><span>可增加细胞带氧能力，加快肌肤代谢</span></p><p><span>·</span><span>含有的蓝白色奇华顿颗粒</span></p><p><span>·</span><span>利用专利的生物溶解技术</span></p><p><span>·</span><span>皮肤呈现透、亮、白、嫩、滑</span></p>',
          '<p><span>·</span><span>乳木果带来独特的‘膜’感护肤</span></p><p><span>·</span><span>具有优越的肌肤再生修复和保湿功能</span></p><p><span>·</span><span>可保护皮脂膜，深入滋养肌肤</span></p><p><span>·</span><span>保持肌肤弹力，抗氧化</span></p>',
        ],
        sliderP: ['pro-p-slider7.png', 'pro-p-slider6.png', 'pro-p-slider1.png', 'pro-p-slider2.png', 'pro-p-slider3.png', 'pro-p-slider4.png', 'pro-p-slider5.png', 'pro-p-slider8.png', 'pro-p-slider9.png', 'pro-p-slider10.png'],
        points: [
          {
            name: 'POINT 1',
            text: '首先进行数分钟头部舒缓放松，使紧张劳累的身心得到快速的解压，进而进行温和的卸妆/洁面工作，使肌肤通透无负担；',
            thumb: 'pd-img1.png',
          },
          {
            name: 'POINT 2',
            text: '正式操作，配合专业手法，进行活性成分15分钟计时注入；',
            thumb: 'pd-img14.png',
          },
          {
            name: 'POINT 3',
            text: '提升按摩3分钟，促进活性成分吸收；静置2分钟，使活性成分充分与肌肤融合，将活性成分擦拭干净；',
            thumb: 'pd-img5.png',
          },
          {
            name: 'POINT 4',
            text: 'pdp细胞更新系列保养品，还原婴儿般本真的美丽肌肤，重塑柔软润泽的肌肤。',
            thumb: 'pd-img4.png',
          },
        ],
      },
      {
        id: '102',
        name: '日式PDP乳糖酸清洁',
        title: '面部毛穴孔深层清洁',
        thumb: 'pro-photo1.png',
        intro: '独有的双向引流技术，配合三款溶液，促进肌肤更新、深层清洁、修复保湿，温和不刺激，可长期和频繁操作，不会对皮肤造成任何伤害。',
        time: '60分',
        price: '¥738（新人价 ¥370）',
        priceList: [
          { type: 'level1', value: 627 },
          { type: 'level2', value: 583 },
          { type: 'level3', value: 554 },
        ],
        position: '面部',
        points: [
          {
            name: 'POINT 1',
            text: '头部舒缓放松，使紧张劳累的身心得到快速的解压，进而进行温和的卸妆/洁面工作，使肌肤通透无负担；',
            thumb: 'pd-img1.png',
          },
          {
            name: 'POINT 2',
            text: '采用pdp乳糖酸焕肤溶液，配合双向引流设备，达成深层清洁的效果，缓解各类因毛孔堵塞、清洁不当造成的各类肌肤问题；',
            thumb: 'pd-img2.png',
          },
          {
            name: 'POINT 3',
            text: 'pdp小分子水果酵素补水面膜，快速镇静肌肤，收缩毛孔，同时进行肩颈放松按摩，倍感轻松的护肤体验；',
            thumb: 'pd-img3.png',
          },
          {
            name: 'POINT 4',
            text: 'pdp细胞更新系列保养品，还原婴儿般本真的美丽肌肤，重塑柔软润泽的肌肤。',
            thumb: 'pd-img4.png',
          },
        ],
      },
      {
        id: '103',
        name: '无针水光深层补水',
        title: '面部细胞深层补水',
        thumb: 'pro-photo2.png',
        intro: '快速激活细胞，修护受损细胞，各项探头加速产品吸收，补水锁水，打开皮肤的吸收通道，使营养成分能够更好的被皮肤吸收，使肌肤水润透白有光泽。',
        time: '70分',
        price: '¥718（新人价 ¥360）',
        priceList: [
          { type: 'level1', value: 610 },
          { type: 'level2', value: 567 },
          { type: 'level3', value: 539 },
        ],
        position: '面部',
        points: [
          {
            name: 'POINT 1',
            text: '首先进行数分钟头部舒缓放松，使紧张劳累的身心得到快速的解压，进而进行温和的卸妆/洁面工作，使肌肤通透无负担；',
            thumb: 'pd-img1.png',
          },
          {
            name: 'POINT 2',
            text: '独有的面部筋络疏通手法，打开面部经络，改善气色，缓解面部暗沉、肤色不均、黑眼圈等多种问题；',
            thumb: 'pd-img5.png',
          },
          {
            name: 'POINT 3',
            text: '开始正式的补水管理，采用日本进口NOAGE综合仪，通过电离子导入、超音波渗透和冷热双头仪，快速的激活面部细胞，修复受损细胞，打开皮肤的吸收通道，使营养成分能够更好的被皮肤吸收；',
            thumb: 'pd-img6.png',
          },
          {
            name: 'POINT 4',
            text: 'pdp小分子水果酵素补水面膜，快速镇静肌肤，收缩毛孔，同时进行肩颈放松按摩，倍感轻松的护肤体验；',
            thumb: 'pd-img3.png',
          },
          {
            name: 'POINT 5',
            text: 'pdp细胞更新系列保养品，还原婴儿般本真的美丽肌肤，重塑柔软润泽的肌肤。',
            thumb: 'pd-img4.png',
          },
        ],
      },
      {
        id: '104',
        name: '黑头管理',
        title: 'T区深层清洁',
        thumb: 'pro-photo3.png',
        intro: '运用两种仪器探头，通过真空引流和高频振动仪器带动毛囊自主运动，在不伤害皮肤，不破坏角质层的前提下，达到快速无痛清除黑头及油脂的效果。',
        time: '45分',
        price: '¥308（新人价¥298、非独立新人价¥198）',
        priceM: '¥308（新人价¥298、¥198）',
        priceList: [
          { type: 'level1', value: 262 },
          { type: 'level2', value: 243 },
          { type: 'level3', value: 231 },
        ],
        position: '鼻部',
        points: [
          {
            name: 'POINT 1',
            text: '首先进行数分钟头部舒缓放松，使紧张劳累的身心得到快速的解压，进而进行温和的卸妆/洁面工作，使肌肤通透无负担；',
            thumb: 'pd-img1.png',
          },
          {
            name: 'POINT 2',
            text: '分别操作真空吸引和电磁波雾化探头，清理毛囊深处及表层代谢出来的油脂黑头，达到更彻底的净化效果，有效缓解和抑制黑头生成；',
            thumb: 'pd-img7.png',
          },
          {
            name: 'POINT 3',
            text: 'pdp小分子水果酵素补水面膜，快速镇静肌肤，收缩毛孔，同时进行肩颈放松按摩，倍感轻松的护肤体验；',
            thumb: 'pd-img3.png',
          },
          {
            name: 'POINT 4',
            text: 'pdp细胞更新系列保养品，还原婴儿般本真的美丽肌肤，重塑柔软润泽的肌肤。',
            thumb: 'pd-img8.png',
          },
        ],
      },
      {
        id: '105',
        name: '白玉钻光护理',
        title: '去黄提亮美白肌肤',
        thumb: 'pro-photo4.png',
        intro: '通过离子导入仪、冷热双头仪，PDT光学应用，将多种高淳养白成分导入皮肤，达到皮肤抗氧去黄，缓解面部暗沉和肤色不均，抑制黑色素生成，分解色素的养白提亮效果。',
        time: '60分',
        price: '¥838（新人价 ¥420）',
        priceList: [
          { type: 'level1', value: 712 },
          { type: 'level2', value: 662 },
          { type: 'level3', value: 629 },
        ],
        position: '面部',
        points: [
          {
            name: 'POINT 1',
            text: '首先进行数分钟头部舒缓放松，使紧张劳累的身心得到快速的解压，进而进行温和的卸妆/洁面工作，使肌肤通透无负担；',
            thumb: 'pd-img1.png',
          },
          {
            name: 'POINT 2',
            text: '浅层和深层电离子导入，通过仿人体生物电流，将烟酰胺、谷胱甘肽、凝血酸等养白成分进行深层导入，展现更上一层的肌肤透白效果；',
            thumb: 'pd-img9.png',
          },
          {
            name: 'POINT 3',
            text: 'PDT美白照射，修复皮肤红印，淡化色素沉着，促进成分吸收；',
            thumb: 'pd-img10.png',
          },
          {
            name: 'POINT 4',
            text: '冷、热双头仪，镇静修复肌肤的同时，导入积雪草、黄岑、光果甘草等多种植物提取物，补水并提亮肤色，淡化暗沉；',
            thumb: 'pd-img11.png',
          },
          {
            name: 'POINT 5',
            text: '镇静滋养面膜，补水保湿，安抚肌肤；',
            thumb: 'pd-img3.png',
          },
          {
            name: 'POINT 6',
            text: 'pdp细胞更新系列保养品，还原婴儿般本真的美丽肌肤，重塑柔软润泽的肌肤。',
            thumb: 'pd-img4.png',
          },
        ],
      },
      // {
      //   id: "106",
      //   name: 'Core Design日本筋膜提升小颜<br class="visiable-detail">紧致管理',
      //   title: "面部肌肉层抗老提升",
      //   thumb: "pro-photo5.png",
      //   intro:
      //     "对面部循环、细胞运动、面部肌肉、皮肤表皮进行弹性刺激，带动面部的肌肉锻炼，从而实现带笑的脸部形态，造就立体脸颊。",
      //   time: "60分",
      //   price: "¥728（新人价 ¥370）",
      //   priceList: [
      //     { type: "level1", value: 619 },
      //     { type: "level2", value: 575 },
      //     { type: "level3", value: 546 },
      //   ],
      //   position: "面部",
      //   points: [
      //     {
      //       name: "POINT 1",
      //       text:
      //         "首先进行数分钟头部舒缓放松，使紧张劳累的身心得到快速的解压，进而进行温和的卸妆/洁面工作，使肌肤通透无负担；",
      //       thumb: "pd-img1.png",
      //     },
      //     {
      //       name: "POINT 2",
      //       text:
      //         "远红外渗透，表皮恒温，真皮加热，刺激皮下组织，对皮肤表皮进行弹性激活；",
      //       thumb: "pd-img13.png",
      //     },
      //     {
      //       name: "POINT 3",
      //       text:
      //         "·放松紧张僵硬的面部肌肉，塑形面部轮廓；<br>·定点定位，同时刺激多个穴位，疏通面部筋络，通过强力的牵 动，使面部肌肉恢复积极的运动，从而促进皮肤的提升；",
      //       thumb: "pd-img5.png",
      //     },
      //     {
      //       name: "POINT 4",
      //       text: "pdp 3D玻尿酸保湿镇静面膜，镇静肌肤、补水保湿、收缩毛孔；",
      //       thumb: "pd-img15.png",
      //     },
      //     {
      //       name: "POINT 5",
      //       text:
      //         "pdp细胞更新系列保养品，还原婴儿般本真的美丽肌肤，重塑柔软润泽的肌肤。",
      //       thumb: "pd-img4.png",
      //     },
      //   ],
      // },
      {
        id: '107',
        name: '豆腐柔肤护理',
        title: '问题肌肤的综合解决方案',
        thumb: 'pro-photo6.png',
        intro: '唤醒及提升皮肤的再生功能，有效提升养份的渗透力，刺激胶原增生，同时兼具增厚角质层的作用，能够有效的增强皮肤的光泽度，水润度，白皙度，修复受损肌肤，改善基底层的健康，对于皮肤毛孔粗大，痘痘痘印痘坑有显著效果。',
        time: '60分',
        price: '¥1608',
        priceInfo: {
          p: require('@/assets/p107.jpg'),
          m: require('@/assets/p107.jpg'),
        },
        priceList: [
          { type: 'level1', value: 1367 },
          { type: 'level2', value: 1270 },
          { type: 'level3', value: 1206 },
        ],
        position: '面部',
        points: [
          {
            name: 'POINT 1',
            text: '首先进行数分钟头部舒缓放松，使紧张劳累的身心得到快速的解压，进而进行温和的卸妆/洁面工作，使肌肤通透无负担；',
            thumb: 'pd-img1.png',
          },
          {
            name: 'POINT 2',
            text: '采用德国进口设备，通过纳米高频探头，进行有效成分的深层注入；三个系列分别为：‘安护’系列-玻尿酸导入；‘神采’系列-VC和玻尿酸导入；‘元气’系列-胶原和玻尿酸导入。因肤因时选择。',
            thumb: 'pd-img16.png',
          },
          {
            name: 'POINT 3',
            text: '贴片冰玲韵医用冷敷膜；',
            thumb: 'pd-img32.png',
          },
          {
            name: 'POINT 4',
            text: '照射PDT修复镇定红光，对皮肤和黏膜有温热作用，刺激血液的流动，加速血液循环，增强人体细胞活力，改善新陈代谢，促进胶原纤维合成，修复皮肤；',
            thumb: 'pd-img10.png',
          },
          // {
          //   name: "POINT 5",
          //   text:
          //     "使用PDP乳木果油护手霜进行手部护理，增强肌肤滋润度，长效保湿，还可以防止紫外线对手部肌肤的损伤。",
          //   thumb: "pd-img18.png",
          // },
        ],
      },
      {
        id: '108',
        name: '镇静舒缓脱敏管理',
        title: '晒后及过敏肌肤的镇静维稳',
        thumb: 'pro-photo7.png',
        intro: '深层冷冻导入，舒缓皮肤灼热刺红、炎症及不适反应，加快肌肤复原；促进血液循环，增强新陈代谢和平衡体内营养供给状态；使皮肤感觉舒适。',
        time: '45分',
        price: '¥498',
        priceList: [
          { type: 'level1', value: 423 },
          { type: 'level2', value: 393 },
          { type: 'level3', value: 374 },
        ],
        position: '面部',
        points: [
          {
            name: 'POINT 1',
            text: '首先进行数分钟头部舒缓放松，使紧张劳累的身心得到快速的解压，进而进行温和的卸妆/洁面工作，使肌肤通透无负担；',
            thumb: 'pd-img1.png',
          },
          {
            name: 'POINT 2',
            text: '高压补水，深层润泽肌肤；',
            thumb: 'pd-img48.jpg',
          },
          {
            name: 'POINT 3',
            text: '深层冷冻导入，配合高纯度玻尿酸原液，进行肌肤的镇静维稳治疗；',
            thumb: 'pd-img11.png',
          },
          {
            name: 'POINT 4',
            text: '修复面膜15分钟，同步照射PDT蓝光，快速抑制炎症，破坏细菌生成加速肌肤痊愈。',
            thumb: 'pd-img5.png',
          },
        ],
      },
    ],
  },
  head: {
    pageClass: 'project2',
    pageTitle: '瞬间进入梦乡的日式温泉护理',
    data: [
      {
        id: '201',
        name: '日本碳酸泉头皮快捷净化',
        title: '净化头皮和发丝',
        thumb: 'pro-head-photo1.png',
        intro: '利用碳酸独有的天然清洁力，去除普通水无法除去的污垢以及附着物，同时收紧头皮，蓬松发根，提高毛发质量，实现富有光泽的“初生秀发”。',
        time: '25分',
        price: '¥158',
        priceInfo: {
          p: require('@/assets/p201.jpg'),
          m: require('@/assets/p201.jpg'),
        },
        // priceList: [
        //   { type: 'level1', value: 98 },
        //   { type: 'level2', value: 88 },
        //   { type: 'level3', value: 78 },
        // ],
        position: '头部',
        points: [
          {
            name: 'POINT 1',
            text: '碳酸泉冲洗，清洗残留在头皮和头发上的洗护残留，油脂，染烫后及附着在头皮和头发上的化学残留物，强化柔顺发质，蓬松发根，收紧头皮；',
            thumb: 'pd-img-head1.png',
          },
          {
            name: 'POINT 2',
            text: '头部热敷，放松头皮紧张的肌肉状态，加速头皮血液循环，改善疲劳；',
            thumb: 'pd-img-head2.png',
          },
          {
            name: 'POINT 3',
            text: '软水洗发，舒适的日式洗发，舒缓头部，清洁头皮及头发；',
            thumb: 'pd-img-head3.png',
          },
          {
            name: 'POINT 4',
            text: '涂抹护发乳，滋养发丝，使发丝柔亮顺滑易打理；',
            thumb: 'pd-img-head4.png',
          },
          {
            name: 'POINT 5',
            text: '吹干头发，并涂抹头皮精华和护发精华，促进健康的毛发生长，给干燥的头皮提供养分，帮助强化发根及防止脱发，顺滑发丝。',
            thumb: 'pd-img-head5.png',
          },
        ],
      },
      {
        id: '202',
        name: 'Head Spa日本碳酸泉<br class="visiable-detail">头皮舒缓管理',
        title: '综合改善头皮环境',
        thumb: 'pro-head-photo2.png',
        intro: '利用纳米微喷软化设备和碳酸泉设备，并结合软水，以及日式头部按摩手法，祛除头皮及头发上残留的化学污垢，缓解头部疲劳。',
        time: '70分',
        price: '¥580',
        priceInfo: {
          p: require('@/assets/p201.jpg'),
          m: require('@/assets/p201.jpg'),
        },
        // priceList: [
        //   { type: 'level1', value: 483 },
        //   { type: 'level2', value: 449 },
        //   { type: 'level3', value: 426 },
        // ],
        position: '头部',
        points: [
          {
            name: 'POINT 1',
            text: '疏通头部经络，主要促进头部血液循环，镇定敏感头皮，松弛肌肉，舒缓心神的效果；',
            thumb: 'pd-img-head6.png',
          },
          {
            name: 'POINT 2',
            text: '运用每秒震动160万次的Spamister离子微喷，为头皮保持湿润的加温，扩张头皮毛孔，软化沉积在头皮的角质，打开头发毛鳞片，使已经变硬的污垢角质变软，便于后续头皮和头发脏污的清洁；',
            thumb: 'pd-img-head7.png',
          },
          {
            name: 'POINT 3',
            text: '碳酸泉冲洗，清洗残留在头皮和头发上的硅油，油脂，染烫后及附着在头皮和头发上的化学残留物，强化柔顺发质，蓬松发根，更有放松头皮的效果；',
            thumb: 'pd-img-head1.png',
          },
          {
            name: 'POINT 4',
            text: '头部热敷后，一边进行敞开微喷，一边进行舒适的日式软水洗发SPA，舒缓头部肌肤，清洁头皮及头发；',
            thumb: 'pd-img-head3.png',
          },
          {
            name: 'POINT 5',
            text: '涂抹头皮头发滋养液，再次配合Spamister恒温加热，加强营养成分的渗透；',
            thumb: 'pd-img-head8.png',
          },
          {
            name: 'POINT 6',
            text: '吹干头发，并涂抹头皮精华和护发精华，促进健康的毛发生长，给干燥的头皮提供养分，帮助强化发根，顺滑发丝。',
            thumb: 'pd-img-head5.png',
          },
        ],
      },
      // {
      //     id: '203',
      //     name: 'Head Spa日本碳酸泉<br class="visiable-detail">头皮舒缓管理-70MINS',
      //     title: '综合改善头皮老化',
      //     thumb: 'pro-head-photo3.jpg',
      //     intro: '利用纳米微喷软化设备和碳酸泉设备，并结合软水，以及日式头部按摩手法，祛除头皮及头发上残留的化学污垢，缓解头部疲劳。',
      //     time: '70分',
      //     price: '568 RMB',
      //     position: '头部',
      //     points: [
      //         {
      //             name: 'POINT 1',
      //             text: '疏通头部经络，主要促进头部血液循环，镇定敏感头皮，松弛肌肉，舒缓心神的效果；',
      //             thumb: 'pd-img-head6.png',
      //         },
      //         {
      //             name: 'POINT 2',
      //             text: '运用每秒震动160万次的Spamister离子微喷，为头皮保持湿润的加温，扩张头皮毛孔，软化沉积在头皮的角质，打开头发毛鳞片，使已经变硬的污垢角质变软，便于后续头皮和头发脏污的清洁；',
      //             thumb: 'pd-img-head7.png',
      //         },
      //         {
      //             name: 'POINT 3',
      //             text: '碳酸泉冲洗，清洗残留在头皮和头发上的硅油，油脂，染烫后及附着在头皮和头发上的化学残留物，强化柔顺发质，蓬松发根，更有收紧头皮的效果；',
      //             thumb: 'pd-img-head1.png',
      //         },
      //         {
      //             name: 'POINT 4',
      //             text: '头部热敷后，一边进行敞开微喷，一边进行舒适的日式软水洗发SPA，舒缓头部肌肤，清洁头皮及头发；',
      //             thumb: 'pd-img-head3.png',
      //         },
      //         {
      //             name: 'POINT 5',
      //             text: '涂抹头皮头发滋养液，再次配合Spamister恒温加热，加强营养成分的渗透；',
      //             thumb: 'pd-img-head8.png',
      //         },
      //         {
      //             name: 'POINT 6',
      //             text: '吹干头发，并涂抹头皮精华和护发精华，促进健康的毛发生长，给干燥的头皮提供养分，帮助强化发根及防止脱发，顺滑发丝。',
      //             thumb: 'pd-img-head5.png',
      //         },
      //     ]
      // },
      {
        id: '204',
        name: 'Apure头皮高级净化',
        title: '深层净化头皮和发丝',
        thumb: 'pro-head-photo4.png',
        intro: '利用碳酸泉设备、专业头皮清洁产品、纳米微喷设备、水压清洁设备，把头皮自身无法代谢和清洁不到的垃圾、角质、污垢彻底清除干净，净化头皮。',
        time: '60分',
        price: '¥620',
        priceInfo: {
          p: require('@/assets/p201.jpg'),
          m: require('@/assets/p201.jpg'),
        },
        // priceList: [
        //   { type: 'level1', value: 585 },
        //   { type: 'level2', value: 544 },
        //   { type: 'level3', value: 516 },
        // ],
        position: '头部',
        points: [
          {
            name: 'POINT 1',
            text: '涂抹头皮角质更新慕斯，促进健康毛发生长，修复损伤毛发以及强化发根，将堵塞在头皮毛孔内的角质废物和头皮屑清理去除，彻底净化头皮；',
            thumb: 'pd-img-head9.png',
          },
          {
            name: 'POINT 2',
            text: '运用每秒震动160万次的Spamister离子微喷，为头皮保持湿润的加温，扩张头皮毛孔，软化沉积在头皮的角质，打开头发毛鳞片，使已经变硬的污垢角质变软，便于后续头皮和头发脏污的清洁；',
            thumb: 'pd-img-head7.png',
          },
          {
            name: 'POINT 3',
            text: '通过超声波振动仪，通过高频能量以及温热效应，疏通颈部淋巴，加速垃圾毒素代谢，并舒缓放松紧张肌肉；',
            thumb: 'pd-img-head10.png',
          },
          {
            name: 'POINT 4',
            text: '碳酸泉冲洗，清洗残留在头皮和头发上的洗护残留，油脂，染烫后及附着在头皮和头发上的化学残留物，强化柔顺发质，蓬松发根，收紧头皮；',
            thumb: 'pd-img-head1.png',
          },
          {
            name: 'POINT 5',
            text: '负离子头皮净化仪，软水通过净化仪转换成水离子，以每分钟1800的水压冲射频率，作用于头皮，把平时自身无法代谢和清洁不到的垃圾，角质，污垢，和以上操作过程中排出的垃圾产物彻底清除干净。',
            thumb: 'pd-img-head11.png',
          },
          {
            name: 'POINT 6',
            text: '两遍软水洗发，舒适的日式洗发，舒缓头部，清洁头皮及头发涂抹护发乳，滋养发丝，使发丝柔亮顺滑易打理；',
            thumb: 'pd-img-head4.png',
          },
          {
            name: 'POINT 7',
            text: '吹干头发，并涂抹头皮精华和护发精华，促进健康的毛发生长，给干燥的头皮提供养分，帮助强化发根及防止脱发，顺滑发丝。',
            thumb: 'pd-img-head5.png',
          },
        ],
      },
    ],
  },
  body: {
    pageClass: 'project3',
    pageTitle: '身体智能管理',
    data: [
      // {
      //   id: "304",
      //   name: "Rich More瑜伽牵引",
      //   title: "全身肌肉放松释放疲劳",
      //   thumb: "pro-body-photo4.png",
      //   intro:
      //     "通过M3复合波直接作用于肌肉，刺激肌肉运动，达到肌肉收缩、肌肉放松的目的。",
      //   time: "55分",
      //   price: "¥568（新人价 ¥340）",
      //   multyPriceList: [
      //     { type: "tag", value: ["独立操作", "非独立操作"] },
      //     { type: "level1", value: [483, 398] },
      //     { type: "level2", value: [449, 370] },
      //     { type: "level3", value: [426, 351] },
      //   ],
      //   // priceInfo: {
      //   //   p: require("@/assets/p301.png"),
      //   //   m: require("@/assets/m301.png"),
      //   // },
      //   position: "适用于全身肌肉群",
      //   points: [
      //     {
      //       name: "Rich More功效",
      //       text:
      //         "针对缺乏运动的人群、久坐需要释放压力和疲劳的人群、肩颈酸痛或其他肌肉疼痛的人群、健身人士缓解运动后的肌肉紧张僵硬、常穿高跟鞋的女士，放松小腿肌肉等几类人群，通过无节拍的m3复合波渗透到肌肉，来达到高效的放松、舒缓紧张的效果。长期操作更可改善人的体态和肢体灵活度。",
      //       thumb: "pd-img-body10.png",
      //     },
      //   ],
      // },
      {
        id: '301',
        name: 'INDIBA身体管理',
        title: '身体细胞平衡疗法',
        thumb: 'pro-body-photo1.png',
        intro:
          '利用进口的细胞平衡温热仪，利用0.44KHZ特殊频率，进行细胞平衡交换，使细胞正、负电荷相互运动、摩擦，产生体内热。体内热能可持续3~4个小时，在此期间新陈代谢时间被延长，促进全身血液和淋巴循环，提高身体自身的免疫力。特别对于女性，体寒会引起女性怕冷，手脚冰凉，痛经，月经不调，有血块等症状。亦能有效分解脂肪，并减少水肿的问题，优化体型。同时促进血液、淋巴循环，提升身体素质。',
        time: '40分',
        price: '¥2380（新人价 ¥780）',
        priceList: [
          { type: 'level1', value: 1904 },
          { type: 'level2', value: 1785 },
          { type: 'level3', value: 1666 },
        ],
        priceInfo: {
          p: require('@/assets/p301.jpg'),
          m: require('@/assets/p301.jpg'),
        },
        position: '全身',
        points: [
          {
            name: '肩颈部位细胞焕能舒压管理',
            text: '激活细胞，活血化瘀，预防颈椎病变，缓解肩颈疲劳、肩周炎及大脑供氧不足引起的头痛和失眠。',
            thumb: 'pd-img-body1.png',
          },
          {
            name: '腰部细胞焕能紧致养生管理',
            text: '改善腰部循环，调节脏腑功能，预防腰椎疾病，调补肾气，提升免疫力。',
            thumb: 'pd-img-body2.png',
          },
          {
            name: '臀部细胞焕能提升养护',
            text: '提高盆腔的供血及供氧量，改善宫寒和痛经，提高臀围线，提升紧实度。',
            thumb: 'pd-img-body3.png',
          },
          {
            name: '胸部细胞焕能紧致疏通管理',
            text: '软坚散结，消炎止痛，疏通乳腺，改善乳腺小叶增生，改善及预防胸部松弛下垂。',
            thumb: 'pd-img-body4.png',
          },
          {
            name: '腹部细胞焕能紧致养生管理',
            text: '改善胃肠道吸收和代谢功能，温宫暖宫；淡化妊娠纹，紧致肌肤，改善松弛，减脂塑形。',
            thumb: 'pd-img-body5.png',
          },
          {
            name: '腿部细胞焕能疏通管理',
            text: '疏通腿部经络，改善末梢循环，改善四肢寒凉问题，预防风湿性关节炎，收紧塑形，改善腿部肥胖。',
            thumb: 'pd-img-body6.png',
          },
          {
            name: '手臂细胞焕能疏通管理',
            text: '改善末梢循环，改善手臂寒凉问题，收紧塑形，告别蝴蝶袖。',
            thumb: 'pd-img-body7.png',
          },
        ],
      },
      {
        id: '302',
        name: 'INDIBA面颈管理',
        title: '面颈肌肤的再生提升和紧致',
        thumb: 'pro-body-photo2.png',
        intro: '再生肌肤，加速代谢的INDIBA，有着很好肌肤提升功效，同时可以提亮肤色、淡化细纹和斑点。',
        time: '35分',
        price: '¥1900（新人价 ¥580）',
        priceList: [
          { type: 'level1', value: 1710 },
          { type: 'level2', value: 1615 },
          { type: 'level3', value: 1520 },
        ],
        priceInfo: {
          p: require('@/assets/p301.jpg'),
          m: require('@/assets/p301.jpg'),
        },
        position: '面部/颈部',
        points: [
          {
            name: '面颈细胞焕能抗衰紧致护理',
            text: '激活细胞，提高皮肤的再生修复和吸收代谢功能，改善面部松弛下垂，紧致提升，打造V脸；改善颈部淋巴循环，避免颈纹的生成，淡化已生成的皱纹。',
            thumb: 'pd-img-body8.png',
          },
        ],
      },
      {
        id: '303',
        name: 'INDIBA眼部管理',
        title: '激活眼周的细胞改善黑眼圈',
        thumb: 'pro-body-photo3.png',
        intro: '再生肌肤，加速代谢的INDIBA，有着很好肌肤提升功效，同时可以提亮肤色、淡化细纹和斑点。',
        time: '35分',
        price: '¥1480（新人价 ¥560）',
        priceList: [
          { type: 'level1', value: 1332 },
          { type: 'level2', value: 1258 },
          { type: 'level3', value: 1184 },
        ],
        priceInfo: {
          p: require('@/assets/p301.jpg'),
          m: require('@/assets/p301.jpg'),
        },
        position: '眼部',
        points: [
          {
            name: '面颈细胞焕能抗衰紧致护理',
            text: '激活眼周的细胞。增加循环代谢，有效的改善黑眼圈，淡化皱纹。',
            thumb: 'pd-img-body9.png',
          },
        ],
      },
    ],
  },
  face: {
    pageClass: 'project4',
    pageTitle: '持久妆',
    data: [
      {
        id: '401',
        name: '自然持久妆美瞳线',
        title: '精细流畅的眼线填充',
        thumb: 'pro-face-photo1.jpg',
        intro: '持久妆技术使用天然色乳施于皮肤表层，形成无比自然的棵妆感，色料不会侵染皮肤，且对身体无害。将黑色色乳细密填充至睫毛根部，打造闭眼无痕，睁眼有神的深邃双眸。',
        time: '30分',
        price: '¥3800（包含免费补色1次）',
        priceInfo: {
          p: require('@/assets/p401.png'),
          m: require('@/assets/m401.png'),
        },
        position: '美瞳线(睫毛根部)',
        points: [
          {
            name: 'POINT 1',
            text: '表皮镇静',
            thumb: 'pd-img-face1.png',
          },
          {
            name: 'POINT 2',
            text: '根据顾客形象气质特征和个人喜好情况，确认内眼线风格。',
            thumb: 'pd-img-face2.png',
          },
          {
            name: 'POINT 3',
            text: '以天然植物色乳施于皮肤表层，对内眼线，即睫毛根部进行施色。',
            thumb: 'pd-img-face3.png',
          },
          {
            name: 'POINT 4',
            text: '局部薄涂再生修护软膏，镇静肌肤。',
            thumb: 'pd-img-face4.png',
          },
        ],
      },
      {
        id: '402',
        name: '自然持久妆眉毛',
        title: '优化眉形与眉色',
        thumb: 'pro-face-photo2.jpg',
        intro: '持久妆技术使用天然色乳施于皮肤表层，形成无比自然的棵妆感，色料不会侵染皮肤，且对身体无害。根据您的眉毛基础、个人喜好、脸型气质，进行眉形设计，优化容貌。',
        time: '45分',
        price: '¥4800（包含免费补色1次）',
        priceInfo: {
          p: require('@/assets/p401.png'),
          m: require('@/assets/m401.png'),
        },
        position: '眉毛',
        points: [
          {
            name: 'POINT 1',
            text: '表皮镇静',
            thumb: 'pd-img-face5.png',
          },
          {
            name: 'POINT 2',
            text: '根据每一位顾客的形象气质特征和个人的喜好情况，来定制完成专属的眉形。',
            thumb: 'pd-img-face6.png',
          },
          {
            name: 'POINT 3',
            text: '以天然植物色乳施于皮肤表层，对眉形进行修饰，均匀眉毛密度。',
            thumb: 'pd-img-face7.png',
          },
          {
            name: 'POINT 4',
            text: '局部薄涂再生修护软膏，镇静肌肤。',
            thumb: 'pd-img-face8.png',
          },
        ],
      },
    ],
  },
};
